import { Provider } from "react-redux";
import { store } from "./store";
import { RouterProvider } from "react-router-dom";
import router from "../router";
import MaintenanceWrapper from "../components/MaintenanceWrapper";

const App = () => {
  
  return (
    <Provider store={store}>
      <MaintenanceWrapper>
        <RouterProvider router={router} />
      </MaintenanceWrapper>
    </Provider>
  );
};

export default App;
